import $ from 'jquery';

var Account = {

    init: function () {
        this.showEditableField();
        this.changeTabs();
        this.deleteAccount();
        this.editAccountInfo();
        this.changeCompany();
        this.changeClient();
    },

    changeCompany: function () {
        jQuery('#company-selector').select2({
            placeholder: jQuery('#company-selector').data('placeholder'),
            dropdownPosition: 'below'
        }).on('select2:select', function (e) {
            window.location = jQuery('#company-selector option:selected').data('url');
        });
    },

    changeClient: function () {
        jQuery('#client-selector').select2({
            placeholder: jQuery('#client-selector').data('placeholder'),
            dropdownPosition: 'below'
        }).on('select2:select', function (e) {
            var currClientId = jQuery('#client-selector option:selected').data('client');

            if (currClientId) {
                jQuery.post('/api/v2/client/client/set/' + currClientId).then(function (resp) {
                    if ('success' == resp.status) {
                        window.location.reload();
                    }
                });
            }
        });
    },

    showEditableField: function () {
        $('.edit-account').click(function(e) {
            e.preventDefault();

            var parentContainer = $(this).parents('.editable');

            $(this).parent().hide();
            parentContainer.find('.editable-container').show();
        });
    },

    changeTabs: function () {
        $('.account__menu-link').click(function() {
            var containerId = $(this).data('id');
            var titleContainerId = $(this).data('title');

            $('.account__menu-link').removeClass('account__menu--active');
            $(this).addClass('account__menu--active');
            $('.account__info-container').hide();
            $(`#${containerId}`).show();

            $('.account__title').not($(`#${titleContainerId}`)).addClass('d-none');
            $(`#${titleContainerId}`).removeClass('d-none');
        });
    },

    deleteAccount: function() {
        $('.remove-account[data-target="#removeAccountModal"]').click(function(e) {
            var data = $(this).data();
            var $modalDiv = $('#removeAccountModal');
            $('#accName', $modalDiv).text(data.name);
            $('.remove-account-approved', $modalDiv).data('accUrl', data.url);
        });

        $('.remove-account-approved').click(function(e) {
            var $modalDiv = window.$('#removeAccountModal');
            var url = $(this).data('accUrl');

            $.post(url).then(function(resp) {
                if ('success' == resp.status && resp.data.id > 0) {
                    window.location.reload();
                } else {
                    $modalDiv.modal('hide');
                    $('#accName', $modalDiv).text('');
                    $('.remove-account-approved', $modalDiv).data('accUrl', '');
                }
            });
        });
    },

    editAccountInfo: function() {
        $('.editAccountInfo').submit(function(e) {
            e.preventDefault();
            console.log(1);
            //Edit account AJAX

            //Hide form and show info
            var parentContainer = $(this).parents('.editable');
            parentContainer.find('.editable-container').hide();
            parentContainer.find('.not-editable-container').show();
        });
    },

    changeSubscriptionn: function() {
        //Subscription AJAX
    }
}

export default Account;
